module.exports = __webpack_public_path__ + "img/selected3-min.15b9a64b.png";